import { useEffect } from 'react'

import { useAxiosHttpClient } from '@/modules/shared/infra/axios-http-client.infra'
import { HttpStatusCode } from '@/modules/shared/protocols/http-client.protocol'

import {
  type TClientProfileService,
  getCustomerProfileService,
} from '../services/get-customer-profile.service'
import { useCustomerProfileStore } from '../stores/customer-profile.store'

export const useCustomerProfileData = () => {
  const { setDataProfile } = useCustomerProfileStore().actions

  const { axiosRequest: requestCustomeProfile } = useAxiosHttpClient({
    sendRequest: getCustomerProfileService,
  })

  const handleGetCustomerProfile = ({ payload }: TClientProfileService) => {
    requestCustomeProfile.mutate({ payload })
  }

  useEffect(() => {
    if (requestCustomeProfile.isSuccess) {
      if (requestCustomeProfile.data.status === HttpStatusCode.OK) {
        setDataProfile(JSON.parse(requestCustomeProfile.data.body))
      }
    }

    // eslint-disable-next-line
  }, [requestCustomeProfile.isLoading])

  return {
    handleGetCustomerProfile,
    isLoading: requestCustomeProfile.isLoading,
  }
}
